import { Organization } from "./types";

export const companyContact: readonly Organization[] = Object.freeze([
  {
    name: "a11yStart",
    slogan: "Boilerplate for startups, accessibility baked and crafted.",
    phone: "",
    email: "contact@a11ystart.blue",
    url: "https://a11ystart.blue",
    logo: "../assets/logo.svg",
    donate: "https://donate.stripe.com/5kA16tezw3OgeKk144",
    description: "A one-person business (micro-entreprise) focused on accessibility-first SaaS tools.",
    sameAs: [
      "https://github.com/br0wsa",
      "https://indiepa.ge/bluecornflakes",
      "http://www.bluecornflakes.com/",
      "https://x.com/a11yStart",
    ],
    postalAddress: {
      streetAddress: "Not disclosed as per Article A123-96 of the French Commercial Code",
      postOfficeBoxNumber: "",
      addressLocality: "",
      addressRegion: "",
      postalCode: "59700",
      addressCountry: "FR",
    },
    legal: {
      editor: {
        name: "Bluecornflakes",
        company: "Micro-Entreprise Bluecornflakes — digital native",
        id: "520 820 549 000 43",
        vatNumber: "none",
        activityCode: "62.01Z - Computer programming",
        businessRegisterLink: "https://a11ystart.blue/legal-notice",
      },

      services: [
        {
          provider: "Mailo — Email hosting (France)",
          type: "mail",
          address: "5 rue Paul Ramier, 94210 Saint Maur des Fausses, France",
          email: "contact@mailo.com",
          website: "https://www.mailo.com",
          privacyPolicy: "https://www.mailo.com/mailo/en/privacy-rules.php",
        },
        {
          provider: "Cloudflare — DNS and protection services",
          type: "web",
          address: "101 Townsend St, San Francisco, CA 94107",
          phone: "+1 650-319-8930",
          email: "abuse+law@cloudflare.com",
          website: "https://cloudflare.com",
          privacyPolicy: "https://cloudflare.com/gdpr",
        },
        {
          provider: "Supabase — PostgreSQL hosting and backend services (EU - Paris)",
          type: "database",
          region: "Europe",
          email: "privacy@supabase.com",
          website: "https://supabase.com",
          privacyPolicy: "https://supabase.com/legal/dpa",
        },
      ],
      rightsAndMention: {
        contentProtection: "This site is a work protected under intellectual property law.",
        reproductionRestriction:
          "Any reproduction or representation made without the consent of the company Bluecornflakes constitutes an infringement.",
        trademark:
          "Bluecornflakes is a registered French trademark with the National Institute of Industrial Property (INPI) under No. 5108082. All mentioned trademarks, product or service names, and logos are the property of their respective owners.",
        designRights: "Logo: Sylvain Ducoulombier",
      },
      dataProtection: {
        cnilDeclaration: "Simplified obligations for micro-entrepreneurs.",
        dpoEmail: "contact@bluecornflakes.com",
      },
    },
    socialMedia: {
      linkedin: "",
      twitter: "https://x.com/a11yStart",
      gitHub: "https://github.com/br0wsa",
      facebook: "",
      instagram: "",
      youtube: "",
      reddit: "",
      stackOverflow: "",
    },
    accessibilityStatement: "https://a11ystart.blue/accessibility",
  },
]);
